var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostureProblem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "\u0421\u043B\u043E\u0439_1",
    viewBox: "0 0 1275.49 2022.69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 31.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1643.13 2455.13c24.88 67.79 24.58 181.5 24.31 201.7a662.31 662.31 0 0 1 -4.15 69.08q-1.15 9.89-2.81 19.72",
    transform: "translate(-1112.26 -738.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2183.13 1339.2s-86.27 3.25-131.53-21.43",
    transform: "translate(-1112.26 -738.65)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 437.92,
    cy: 1675.97,
    rx: 174.76,
    ry: 171.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.57,
    cy: 858,
    rx: 211.62,
    ry: 207.68
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1112.26 -738.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2075.42 1599c-14.29-34.33-33.83-69.72-56.37-102.93-46.67-8.79-161.76-41.28-222.23-153.12a61.58 61.58 0 0 0 -13.68 7.78c-26.33 19.69-55.63 43.74-84.93 73.85a723.79 723.79 0 0 0 -49 57.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2187.43 2740q-4.76-23.81-9.16-46.81c-141.7-737.44-20.86-791.53-85.28-1042.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1522.09 2068.19c-12.5-86.63-13.17-176.5 1.83-273.63q2.08-13.48 4.56-27.2c2.5-13.74 10.54-48.37 13.63-61.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1594.7 2327.43c-28-71.6-50.22-138.63-64.46-211.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2187.43 2740q-4.76-23.81-9.16-46.81c-1.86-9.69-3.69-19.3-5.47-28.76-10.23-54-19.15-104.75-26.92-152.57-41.39 6.93-81.16 11.83-118.91 15.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1818.46 2531c-26.25-1.36-49.8-3.27-70.3-5.41-23.12-2.41-42.3-5.06-57.09-7.35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m760.02 2001.39-101.87-395.73-10.61-534.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904.34 1024.55-27.59 564.44 78.52 412.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m955.27 2001.39-78.52-412.4 14.86-304.02h-239.31l5.85 320.69 101.87 395.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2105.17 756.3c53.3 8 103.08 30.58 126.5 42.72 50.79 26.34 100.59 26.34 100.59 26.34 32.39 63-31.76 89.92-31.76 89.92-68.51 9.38-113.08 61.64-113.08 61.64-18.2 65.84-54.4 92.88-54.4 92.88-17.25-29.14-48.69-54.51-48.69-54.51-85.09-43.27-79.69 94-79.69 94-42.38 60.12-95 74.13-96.66 74.59s-96.39-90.7-85-204.87c14.31-143.74 117.52-151.79 117.52-151.79 24.78-48.65 64.8-68.48 107.81-72.87",
    transform: "translate(-1112.26 -738.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.71 918.68 150.87-10.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.94 978.01-136.6 52.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.83 1039.87-98.44 91.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141 1373.09 95.48 115.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.16 1541.35-122.55-79.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.41 1605.82-132.6-26.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2372 1147.83s-18.67 15.53-40.24 25.41c0 0-13.68 55.18-24.46 99.38a71.2 71.2 0 0 1 -53.68 52.41c-23.63 5.37-55.35 11.91-91.39 17.7 0 0-101.9 26.89-122.79 156.42 0 0-7.65-.62-20.42-3-46.67-8.79-161.77-41.28-222.23-153.12a1 1 0 0 1 -.16-.27s96.42-68.21 111.29-158.84c1.7-.47 54.28-14.48 96.66-74.59 0 0-5.39-137.28 79.69-94 0 0 31.44 25.37 48.69 54.51 0 0 36.2-27 54.4-92.88 0 0 44.56-52.26 113.08-61.64 14.79 39.81 32.83 103.5 14 139.46z",
    transform: "translate(-1112.26 -738.65)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.89,
    cy: 1675.97,
    rx: 95.68,
    ry: 93.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.57,
    cy: 858,
    rx: 117.11,
    ry: 114.93
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureProblem);
export default __webpack_public_path__ + "static/media/posture-problem.29d9c965d0d267e78565c80150ec7f39.svg";
export { ForwardRef as ReactComponent };